// Fetches the player count for the server IP from the mcsrvstat.us API.

import { useEffect, useState } from 'react';
import Skeleton from '../components/Skeleton';
import useCountUp from '../hooks/useCountUp';

const SERVER_IP = '192.99.46.76';

const ServerStatus = () => {
  const [playerCount, setPlayerCount] = useState(null);
  const [online, setOnline] = useState(null);
  const displayed = useCountUp(playerCount);

  useEffect(() => {
    let cancelled = false;

    const fetchPlayerCount = async () => {
      try {
        const response = await fetch(`https://api.mcsrvstat.us/3/${SERVER_IP}`);
        const data = await response.json();
        if (cancelled) return;
        setOnline(Boolean(data.online));
        setPlayerCount(data.online ? data.players.online : 0);
      } catch (error) {
        console.error('Error fetching player count:', error);
        if (!cancelled) setOnline(false);
      }
    };

    fetchPlayerCount();
    return () => {
      cancelled = true;
    };
  }, []);

  if (online === null) {
    return (
      <p>
        Server Status: <Skeleton className="skeleton--inline" as="span" /> players
      </p>
    );
  }

  // Previously rendered "Server Status: Server Offline players".
  if (!online) {
    return <p>Server Status: Offline</p>;
  }

  return (
    <p>
      Server Status: <span className="tabular">{displayed ?? 0}</span> players
    </p>
  );
};

export default ServerStatus;
